/**
 * Check if a richtext HTML string has meaningful content.
 * Returns the original string if it has content, or null if empty.
 * Treats strings like "<p><br></p>" or "<p> </p>" as empty.
 */
export function richTextOrNull(html) {
    if (!html) return null;
    const stripped = html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
    return stripped.length > 0 ? html : null;
}

/**
 * Strip block-level HTML tags from a string, keeping only inline content.
 * Useful for Builder richText fields rendered inside headings.
 */
export function stripBlockTags(html) {
    if (!html) return '';
    return html
        .replace(/<\/?(p|div|span|h[1-6]|ul|ol|li|blockquote|section|article|header|footer|nav|figure|figcaption|main|aside|details|summary|table|thead|tbody|tfoot|tr|td|th)(\s[^>]*)?>/gi, '')
        .replace(/\s*style="[^"]*"/gi, '')
        .trim();
}
